import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { notBlankValidation, priceValidation } from '../../../utils/validations';
import Input from '../../shared/input/Input';

const RateForm = ({ onSubmit, initRate = {}, readOnly, loading }) => {
  const methods = useForm({ defaultValues: initRate });
  return (
    <FormProvider {...methods}>
      <form id="rate-form" noValidate className="modal-form" onSubmit={methods.handleSubmit((data) => onSubmit(data))}>
        <Input
          label="Назва оцінки вартості"
          type="input"
          name="name"
          autoFocus="true"
          disabled={readOnly || loading}
          placeholder={'Введіть назву оцінки вартості'}
          validation={notBlankValidation}
        />
        <Input
          label="Ціна нормо-години"
          type="number"
          name="price"
          disabled={readOnly || loading}
          placeholder={'Введіть ціну нормо-години'}
          validation={priceValidation}
        />
      </form>
    </FormProvider>
  );
};

export default RateForm;
